<div class="">
  <div #contenedorDias class="row center-block" id="contenedorDias" style="position: sticky">
    <div #contenedorInterno style="overflow: auto; position: relative;"
      [ngClass]="{'d-flex justify-content-center': !totalDays }">
      <div *ngFor="let day of days;let i = index" class="noPLPR dateBlock2 center-block"
        [ngClass]="{'currentDate' : day.Date == value}" [focus]="active && i == 0" [tabindex]="i"
        (click)="clickDia(day);">
        <div class="month">{{day.Month}}</div>
        <div class="numDay">{{day.DayOfMonth}}</div>
        <div #divDiaSemana class="dayWeek" [innerHtml]="day.DayOfWeek"></div>
      </div>
    </div>
  </div>
  <div class="nextDate" *ngIf="totalDays">
    <button type="button" (click)="scrollAbove()" [disabled]="!scrollAboveEnabled"> <i class="bi bi-chevron-up"></i>
    </button>

    <button type="button" (click)="scrollDown()" [disabled]="!scrollDownEnabled"><i class="bi bi-chevron-down"></i>
    </button>
  </div>
</div>